import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac8222ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "left-side half",
  ref: "leftRef"
}
const _hoisted_2 = ["onClick", "onContextmenu", "onDblclick"]
const _hoisted_3 = { class: "option-content" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "swap-items" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line" }, null, -1))
const _hoisted_7 = {
  class: "right-side half",
  ref: "rightRef"
}
const _hoisted_8 = { class: "options-list un-selected-list" }
const _hoisted_9 = ["onClick", "onContextmenu", "onDblclick"]
const _hoisted_10 = { class: "option-content" }
const _hoisted_11 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_PageFooter = _resolveComponent("PageFooter")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_InputField = _resolveComponent("InputField")!

  return (_openBlock(), _createBlock(_component_InputField, {
    class: "multi-select",
    disabled: _ctx.disabled,
    error: _ctx.error,
    success: _ctx.success,
    label: _ctx.label,
    "label-icon": _ctx.labelIcon,
    "label-icon-class": _ctx.labelIconClass,
    name: _ctx.name
  }, {
    input: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_draggable, {
          class: "options-list selected-list",
          modelValue: _ctx.selectedItems,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems) = $event)),
          "item-key": "value",
          "force-fallback": true,
          disabled: !_ctx.sortable,
          filter: ".no-drag"
        }, {
          item: _withCtx(({ element: option, index }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["option", {
                                marked: _ctx.isIncluded(option, _ctx.markedLeft),
                                'pre-marked': _ctx.isPreMarked(
                                    index,
                                    _ctx.selectedItems,
                                    _ctx.markedLeft
                                ),
                                sortable: _ctx.sortable,
                            }]),
              onClick: _withModifiers(($event: any) => (
                                _ctx.clickHandler($event, option, index, 'left')
                            ), ["prevent"]),
              onContextmenu: _withModifiers(($event: any) => (
                                _ctx.clickHandler($event, option, index, 'left')
                            ), ["prevent"]),
              onDblclick: ($event: any) => (_ctx.unSelectOne(option))
            }, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.sortable)
                  ? (_openBlock(), _createBlock(_component_IconBase, {
                      key: 0,
                      icon: "arrow-up-down",
                      class: "arrow-icon"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_4, _toDisplayString(option.label), 1)
              ])
            ], 42, _hoisted_2)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        (_ctx.isMounted)
          ? (_openBlock(), _createBlock(_component_PageFooter, {
              key: 0,
              scrollArea: _ctx.leftRef,
              ready: true
            }, null, 8, ["scrollArea"]))
          : _createCommentVNode("", true)
      ], 512),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["swap swap-left", { disabled: !_ctx.markedRight.length }]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveLeft && _ctx.moveLeft(...args)))
        }, [
          _createVNode(_component_IconBase, {
            class: "arrow-icon left-arrow-icon",
            icon: "chevron-left"
          })
        ], 2),
        _hoisted_6,
        _createElementVNode("div", {
          class: _normalizeClass(["swap swap-right", { disabled: !_ctx.markedLeft.length }]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveRight && _ctx.moveRight(...args)))
        }, [
          _createVNode(_component_IconBase, {
            class: "arrow-icon right-arrow-icon",
            icon: "chevron-right"
          })
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_TextField, {
          text: _ctx.search,
          "onUpdate:text": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
          class: "multi-select-search",
          icon: "search"
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unSelectedItems, (option, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["option", {
                            marked: _ctx.isIncluded(option, _ctx.markedRight),
                            'pre-marked': _ctx.isPreMarked(
                                i,
                                _ctx.unSelectedItems,
                                _ctx.markedRight
                            ),
                            disabled: option.disabled,
                            'group-title': option.optGroup,
                        }]),
              key: i,
              onClick: _withModifiers(($event: any) => (
                            _ctx.clickHandler($event, option, i, 'right')
                        ), ["prevent"]),
              onContextmenu: _withModifiers(($event: any) => (
                            _ctx.clickHandler($event, option, i, 'right')
                        ), ["prevent"]),
              onDblclick: ($event: any) => (_ctx.selectOne(option))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(option.label), 1)
              ])
            ], 42, _hoisted_9))
          }), 128))
        ]),
        (_ctx.isMounted)
          ? (_openBlock(), _createBlock(_component_PageFooter, {
              key: 0,
              scrollArea: _ctx.rightRef,
              ready: true
            }, null, 8, ["scrollArea"]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _: 1
  }, 8, ["disabled", "error", "success", "label", "label-icon", "label-icon-class", "name"]))
}